import React from 'react';
import EditRepresentativeApplicationPage from '../../../../pages/EditRepresentativeApplicationPage';
import NewRepresentativeApplicationPage from '../../../../pages/NewRepresentativeApplicationPage';
import RepresentativeApplicationPage from '../../../../pages/RepresentativeApplicationPage';
import RepresentativeProfilePage from '../../../../pages/RepresentativeProfilePage';

import { RoutePathsType } from '../../../../types';
import { routerPath } from '../../../routerPath';

export const representativeRoutes: RoutePathsType = [
  {
    path: routerPath.representativeProfile,
    name: 'Профиль',
    Component: <RepresentativeProfilePage />,
  },
  {
    path: routerPath.representativeApplication,
    name: 'Заявления',
    Component: <RepresentativeApplicationPage />,
  },
  {
    path: routerPath.newRepresentativeApplication,
    name: 'Новое завяление',
    Component: <NewRepresentativeApplicationPage />,
  },
  {
    path: routerPath.editRepresentativeApplicationId,
    name: 'Изменение заявления',
    Component: <EditRepresentativeApplicationPage />,
  },
];
